import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getAsyncItemRegistry } from "../selectors/getAsyncItemRegistry";

/**
 * Marks a tracked async item as read locally so the unread indicator clears immediately on
 * click (optimistic UI). No-op if untracked.
 *
 * The service still owns the authoritative read state; a later seed reconciliation overwrites
 * this if it disagrees.
 */
export const markAsyncItemReadMutator: (mailboxInfo: MailboxInfo, id: string) => void = mutatorAction("markAsyncItemReadMutator", (mailboxInfo: MailboxInfo, id: string): void => {
    const entry = getAsyncItemRegistry(mailboxInfo)?.entriesById.get(id);
    if (entry && entry.isUnread) {
        entry.isUnread = false;
    }
});
